
<template>
<!-- 事件分析 -->
  <div chass="app-container" class="fl" style="width:100%;font-size:12px">
    <div class="chart-container fl" style="background: #fff;width:100%">
      <div>
        <el-button @click="addbaobiao" slot="reference" size="mini" icon="el-icon-circle-plus-outline">新增报表</el-button>
        <el-button @click="draweropen" slot="reference" size="mini" icon="el-icon-folder-opened">已存报表</el-button>
        <el-drawer title="" size="700px" :visible.sync="drawer" :before-close="handleClose">

          <el-input v-model="gridDatasousuo" placeholder="请输入内容" prefix-icon="el-icon-search" @input="gridDatasousuoinput" style="margin: 0 20px; width: 300px;"></el-input>

          <el-table :data="gridData" :show-header='true' style="margin-top:30px;" :height="tableHeight">
            <el-table-column property="name" label="报表名称">
              <template slot-scope="scope">
                <div style="width:220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="scope.row[scope.column.property]">
                  {{scope.row[scope.column.property]}}
                </div>
              </template>
            </el-table-column>
            <el-table-column property="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column property="useed" label="使用状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.useed" style="color:#1890ff">
                  已使用
                </span>
                <span v-if="scope.row.useed==false" style="color:#EE6363">
                  未使用
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button size="mini" style="color:#1890ff" @click="handleEditupdate(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" style="color:#EE6363" @click="handleEditremove(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-drawer>
      </div>
      <el-row :gutter="20">
        <!-- :style="modelloading[item.code]?'min-height:300px;':''" -->
        <el-col :span="24">
          <!-- <h5>事件分析</h5> -->
          <div class='liaojianliebiao fl' style="margin-top:10px;">
            <div class="tiaojianyijilist">
              <div class="tiaojianyijiname fl">报表名称</div>
              <div class="tiaojianyijiselect_list1 fl">
                <el-input v-model="objdata.name" size="small"></el-input>
              </div>
            </div>
            <div class="tiaojianyijilist">
              <div class="tiaojianyijiname fl" style="margin-left:50px;">报表说明</div>
              <div class="tiaojianyijiselect_list1 fl">
                <el-input v-model="objdata.desc" style="width:500px" size="small"></el-input>
              </div>
            </div>
          </div>
          <div class='liaojianliebiao fl'>

            <!-- <draggable v-model="objdata.tables" group="people1" @chang="change" @start="start" @end="end" :move="move" :handle="'.tuozhuaibtn1'"> -->
            <div v-for="(eventslist,eventsindex) in objdata.tables" :key="eventsindex" class="tiaojianyijilist fl tiaojianyijilistlastbottom tiaojianyijilistlast" style="">
              <!--  {{eventsindex+1}} -->
              <div class="tiaojianyijiname fl">查询表</div>
              <div class="tiaojianyijiselect_list fl">
                <div style="width:800px;float:left">
                  <div class="tiaojianyijiselect_item fl">
                    <el-select placeholder="表" style="width:200px" size="small" clearable filterable v-model="eventslist.eventCode" @change="selectforname($event,eventslist,eventdatas)">
                      <el-option v-for="(tablesform,findex) in eventdatas" :key="findex" :value="tablesform.eventCode" :label="tablesform.tableDesc"></el-option>
                    </el-select>

                  </div>
                  <!-- <div class="fl mgleft" @click="addeventslist($event,objdata.tables)">
                      <svg-icon icon-class="add" style="width:20px;height:20px;margin-top: 12px;float: left;color:#646cf5" />
                    </div>
                    <div class="fl mgleft" v-show="objdata.tables.length>1" @click="removeeventslist($event,eventsindex)">
                      <svg-icon icon-class="shanchu" style="color:ff0000;width:20px;height:20px;margin-top: 12px;float: left;" />
                    </div>
                    <el-button title="排序" v-show="objdata.tables.length>1" class="el-icon-rank fl mgleft tuozhuaibtn1" style="border:none;margin-top: 5px;"></el-button> -->
                </div>

                <draggable style="margin-left:50px;width:800px" v-model="eventslist.columns" :group="'people2'+eventsindex" :handle="'.tuozhuaibtn'" @chang="change" @start="start" @end="end" :move="move">
                  <div v-for="(list,listindex) in eventslist.columns" :key="listindex" style="width:100%;float:left;border-top:1px solid #dedede">
                    <div class="tiaojianyijiname fl">查询字段 {{listindex+1}}</div>
                    <div class="tiaojianyijiselect_item fl notuozhuaibtn">
                      <el-select placeholder="字段" style="width:200px" filterable size="small" clearable v-model="list.trueField" @change="selectziduan($event,list,eventslist.columnslist)">
                        <el-option v-for="(columnsform,cindex) in eventslist.columnslist" :key="cindex" :value="columnsform.trueField" :label="columnsform.fieldDesc"></el-option>
                      </el-select>
                    </div>
                    <div class="tiaojianyijiselect_item fl" v-if="list.cmm" style="margin-left:10px">
                      <el-input placeholder="重命名" size="small" v-model="list.fieldDesc" style="width:200px" clearable></el-input>
                    </div>
                    <div class="fl mgleft notuozhuaibtn" @click="addeventslistzi($event,eventslist.columns)">
                      <svg-icon icon-class="add" style="width:20px;height:20px;margin-top: 12px;float: left;color:#646cf5" />
                    </div>
                    <div class="fl mgleft notuozhuaibtn" v-show="eventslist.columns.length>1" @click="removeeventslistzi($event,eventslist.columns,listindex)">
                      <svg-icon icon-class="shanchu" style="color:ff0000;width:20px;height:20px;margin-top: 12px;float: left;" />
                    </div>

                    <div class="fl mgleft notuozhuaibtn">
                      <el-button type="text" size="mini" v-if="!list.cmm" @click="list.cmm=true">重命名</el-button>
                      <el-button type="text" size="mini" v-if="list.cmm" @click="clickziduan($event,list.trueField,list,eventslist.columnslist)">取消重命名</el-button>
                    </div>
                    <el-button title="排序" v-show="eventslist.columns.length>1" class="el-icon-rank fl mgleft tuozhuaibtn" style="border:none;margin-top: 5px;"></el-button>
                  </div>
                </draggable>
              </div>
            </div>
            <!-- </draggable> -->
          </div>
          <!-- <div class='liaojianliebiao fl'>
            <div class="tiaojianyijilist">
              <div class="tiaojianyijiname fl">查询时间</div>
              <div class="tiaojianyijiselect_list fl">
                <el-select v-model="objdata.timeType" @change="timetypechange" size="small" style="width:100px;">
                  <el-option label="两日内" value="1"></el-option>
                  <el-option label="两日前" value="2"></el-option>
                </el-select>
                <el-date-picker size="small" v-model="objdata.selecttime" type="daterange" placeholder="选择日期" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="objdata.pickerOptions"
                  :editable="false" style="width:230px;">
                </el-date-picker>
              </div>
            </div>
          </div> -->

          <el-button type="primary" size="mini" @click="chaxunbtn" style="width:70px;margin-left:30px;float:left;margin-top:10px">查询</el-button>
          <el-button type="primary" size="mini" @click="baocunbtn" v-show="chaxunchengong" style="width:70px;margin-left:30px;float:left;margin-top:10px">保存</el-button>
          <el-button type="primary" size="mini" @click="lingbaocunbtn" v-show="chaxunchengong" style="width:70px;margin-left:30px;float:left;margin-top:10px">另存为</el-button>
          <div class="fl" style="width:100%;margin-top:20px;margin-bottom:20px">
            <!-- <div class="" v-show="chaxunchengong" style="float:left;margin-left:1%;margin-top:10px;margin-bottom:10px;width:100%">
              <el-button slot="reference" style="font-size: 12px;padding: 7px 15px;" @click="bianjilieclick">编辑列</el-button>
            </div> -->
            <el-tag v-show="chaxunchengong">默认返回前10条，如需查看更多，请保存此报表后在我的菜单中查询</el-tag>
            <el-table v-loading="modelloading" :data="tableData.page.result" style="width:100%;float:left" height="450" border>
              <el-table-column v-for="itemtable1 in tableData.thead" :label="itemtable1.label" :key="itemtable1.property" :property="itemtable1.property">
                <template slot-scope="scope">
                  <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;" @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                    {{scope.row[scope.column.property] | neirongsuojian}}
                  </span>
                  <span v-else>
                    {{scope.row[scope.column.property]}}
                  </span>
                </template>
                <el-table-column v-for="itemtable2 in itemtable1.list" :label="itemtable2.label" :key="itemtable2.property" :property="itemtable2.property">
                  <template slot-scope="scope">
                    <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;" @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                      {{scope.row[scope.column.property] | neirongsuojian}}
                    </span>
                    <span v-else>
                      {{scope.row[scope.column.property]}}
                    </span>
                  </template>
                  <el-table-column v-for="itemtable3 in itemtable2.list" :label="itemtable3.label" :key="itemtable3.property" :property="itemtable3.property">
                    <template slot-scope="scope">
                      <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;" @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                        {{scope.row[scope.column.property] | neirongsuojian}}
                      </span>
                      <span v-else>
                        {{scope.row[scope.column.property]}}
                      </span>
                    </template>

                  </el-table-column>
                </el-table-column>
              </el-table-column>
            </el-table>
            <!-- <div class="block" style="padding-bottom:10px">
              <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="sizePage" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength"
                style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div> -->
          </div>

        </el-col>
      </el-row>
    </div>
    <!-- shaixuantanchukuang @start="drag=true" @end="drag=false"  -->
    <el-dialog title="编辑列" :visible.sync="shaixuantanchukuang" top='5vh' width="600px" height="300px">
      <draggable v-model="tableData.ttitle" group="people" @chang="change" @start="start" @end="end" :move="move">
        <div v-for="(listdis,listdisindex) in tableData.ttitle" :key="listdisindex" class="bianjilie_div">
          <el-input v-model='listdis.label' @change='changeinput($event,listdis.property)' style="max-width:200px;float:left;font-size:10px" size="mini"></el-input>
          <el-switch size="mini" style="float:left;height:28px;border:1px solid #dedede;padding:0px 10px;border-radius:6px;" v-model="listdis.state" active-text="显示" active-value="1" active-color="#13ce66"
            inactive-text="隐藏" inactive-value="0" inactive-color="#ff4949" @change="changeswitch($event,listdis.property)">
          </el-switch>
          <el-switch size="mini" v-if="listdis.arrangement!='0'" :disabled="listdis.arrangement=='4'" style="float:left;height:28px;border:1px solid #dedede;padding:0px 10px;border-radius:6px;"
            v-model="listdis.arrangement" active-text="横排" active-value="2" active-color="#13ce66" inactive-text="竖排" inactive-value="1" inactive-color="#ff4949" @change="changehengshu($event,listdis.property)">
          </el-switch>
          <el-button class="el-icon-rank" style="border:none"></el-button>
        </div>
      </draggable>

      <div v-if="tableData.mtitle">
        <div style="font-size:16px;color:#666;width:100%;border-top:1px solid #dedede;float:left;margin-top: 10px;padding-left: 20px;padding-bottom: 10px;padding-top: 10px;">合并列</div>
        <div v-for="(listdis,listdisindex) in tableData.mtitle" :key="listdisindex" class="bianjilie_div">
          <el-input v-model='listdis.label' style="max-width:200px;float:left;font-size:10px" size="mini" disabled></el-input>
          <el-switch size="mini" style="float:left;height:28px;border:1px solid #dedede;padding:0px 10px;border-radius:6px;" v-model="listdis.state" active-text="是" active-value="1" active-color="#13ce66"
            inactive-text="否" inactive-value="0" inactive-color="#ff4949" @change="changeswitchhebin($event,listdis.property)">
          </el-switch>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bianjiliechaxun" style="font-size: 12px;padding: 7px 15px;">确定查询</el-button>
      </div>

    </el-dialog>
    <el-dialog title="返回内容" :visible.sync="adddivif" width="90%" top="5vh">
      <el-row>
        <el-col :span="24">
          <div v-if="jsonif == 'html'" style="height:500px;overflow-y: scroll">
            <json-editor ref="jsonEditor" v-html="jsontext" />
          </div>
          <div v-if="jsonif == 'json'" style="height:500px;overflow-y: scroll">
            <json-editor ref="jsonEditor" v-model="jsontext" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" style="float:right;margin-top:10px;margin-right:20px" @click="hidedivshow">确定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import echarts from '@Bdc~/views/gameData/components/chartPage'
import draggable from "vuedraggable";
import JsonEditor from "@/components/JsonEditor";
import {
  fenxisave,
  fenxiquery,
  ajax_zhibiaoliebiao,
  ajax_zhibiaodel,
  queryByCode,
  ajax_gm_handleBusinessByTargetKpi,
  ajax_gm_customqueryTest
} from "@Gms~/api/ajax_model";

export default {
  name: "eventanalysis",
  components: {
    echarts,
    draggable,
    JsonEditor
  },
  data() {
    return {
      jsonif: 'json',
      jsontext: {},
      adddivif: false,
      shaixuantanchukuang: false,
      huisubtn: false,
      tableHeight: window.innerHeight - 100,
      gridData: [],
      drawer: false,
      alltext: [],
      allcode: "",
      defaultsort: { prop: "date", order: "descending" },
      chaxunchengong: false,
      modelloading: false,
      tableData: { tbody: [], thead: [], ttitle: [], page: { result: [] } },
      chartData: "",
      currentPage: 1,
      dataLength: 1,
      sizePage: 10,
      shijianliebiao: [],
      objdata: {
        titles: [],
        name: "",
        code: "",
        userId: this.$store.getters.userId,
        userName: this.$store.getters.userInfo.realname,
        desc: "",
        platform: this.$store.getters.environment,
        appkey: this.$store.getters.appkey,
        // timeType: "1",
        // queryTime: "",
        selecttime: [
          new Date(
            new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)
          ).Format("yyyy-MM-dd"),
          new Date(
            new Date()
          ).Format("yyyy-MM-dd")
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 24 * 2 * 3600 * 1000) || time.getTime() > Date.now();
          },
        },
        tables: [
          {
            tableName: "",
            eventCode: "",
            columns: [
              {
                eventCode: "",
                trueField: "",
                fieldDesc: "",
                colType: "",
                translate: "",
                orderType: "",
                orderNum: "",
                cmm: false
              }
            ],
            columnslist: []
          }
        ]
      },

      eventslistobj: {
        eventCode: {},
        trueField: {},
        fieldDesc: {},
        colType: {},
        translate: {},
        orderType: {},
        orderNum: {},
        cmm: {}
      },

      eventslistobjwai: {
        tableName: {},
        eventCode: {},
        columns: {},
        columnslist: {}
      },

      nums: 99,
      modelvalue: "",
      eventdatas: [],
      options: [],
      shijian: [],
      xinzengtype: true,

      //已存报表快速搜索
      gridDatasousuo: '',
      originalGridData: [], // 已存报表原始数据

    };
  },
  created() {
    this.initevent();
  },
  mounted() { },
  methods: {

    // timetypechange(e) {
    //   if (e == 1) {
    //     this.objdata.selecttime = [
    //       new Date(
    //         new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)
    //       ).Format("yyyy-MM-dd"),
    //       new Date(
    //         new Date()
    //       ).Format("yyyy-MM-dd")
    //     ],
    //       this.objdata.pickerOptions = {
    //         disabledDate(time) {
    //           return time.getTime() < (Date.now() - 24 * 2 * 3600 * 1000) || time.getTime() > Date.now();
    //         },
    //       }
    //   } else if (e == 2) {
    //     this.objdata.selecttime = [
    //       new Date(
    //         new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 9)
    //       ).Format("yyyy-MM-dd"),
    //       new Date(
    //         new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)
    //       ).Format("yyyy-MM-dd")
    //     ],
    //       this.objdata.pickerOptions = {
    //         disabledDate(time) {
    //           return time.getTime() > (Date.now() - 24 * 2 * 3600 * 1000);
    //         },
    //       }
    //   }
    // },
    isjson(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
    },
    jinruyouxi(index, row, property) {
      if(this.isjson(row[property])){
        this.jsonif = "json"
        this.jsontext = JSON.parse(row[property]);
      } else {
        this.jsonif = "html"
        this.jsontext = row[property].replace(/;/g, "<br>")
      }
      this.adddivif = true;
    },
    hidedivshow() {
      this.adddivif = false;
    },
    change(event) {
      console.log("change", event);
    },
    start(event) {
      console.log("start", event);
    },
    end(event) {
      console.log("end", event, this.tableData.ttitle);
    },
    move(event, orgin) {
      console.log("move", event, orgin);
    },
    bianjilieclick() {
      this.shaixuantanchukuang = true;
    },
    initevent() {
      ajax_gm_handleBusinessByTargetKpi(
        "find_tables_gms",
        {}
      ).then(response => {
        console.log("find_tables_gms", response.data);
        if (response.code == 1) {
          this.eventdatas = response.data;
        }
      });
    },
    addeventslistzi(e, obj) {
      console.log(obj);
      var id = this.nums++;
      this.eventslistobj.eventCode[id] = "";
      this.eventslistobj.trueField[id] = "";
      this.eventslistobj.fieldDesc[id] = "";
      this.eventslistobj.colType[id] = "";
      this.eventslistobj.translate[id] = "";
      this.eventslistobj.orderType[id] = "";
      this.eventslistobj.orderNum[id] = "";
      this.eventslistobj.cmm[id] = false;
      var eventslistobj = {
        eventCode: this.eventslistobj.eventCode[id],
        trueField: this.eventslistobj.trueField[id],
        fieldDesc: this.eventslistobj.fieldDesc[id],
        colType: this.eventslistobj.colType[id],
        translate: this.eventslistobj.translate[id],
        orderType: this.eventslistobj.orderType[id],
        orderNum: this.eventslistobj.orderNum[id],
        cmm: this.eventslistobj.cmm[id]
      };
      obj.push(eventslistobj);
    },
    addeventslist(e, obj) {
      var id = this.nums++;
      this.eventslistobjwai.tableName[id] = "";
      this.eventslistobjwai.eventCode[id] = "";
      this.eventslistobjwai.columns[id] = [
        {
          eventCode: "",
          trueField: "",
          fieldDesc: "",
          colType: "",
          translate: "",
          orderType: "",
          orderNum: "",
          cmm: false
        }
      ];
      this.eventslistobjwai.columnslist[id] = [];
      var eventslistobjwai = {
        tableName: this.eventslistobjwai.tableName[id],
        eventCode: this.eventslistobjwai.eventCode[id],
        columns: this.eventslistobjwai.columns[id],
        columnslist: this.eventslistobjwai.columnslist[id]
      };
      obj.push(eventslistobjwai);
    },
    removeeventslistzi(e, obj, i) {
      obj.splice(i, 1);
    },
    removeeventslist(e, i) {
      this.objdata.tables.splice(i, 1);
    },
    cascaderselect(e) { },
    selectforname(e, obj, arr) {
      // this.objdata.code = "";
      console.log(e);
      console.log(obj);
      console.log(arr);
      var formid = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].eventCode == e) {
          formid = arr[i].tableName;
        }
      }
      obj.tableName = formid;
      obj.columns = [
        {
          eventCode: "",
          trueField: "",
          fieldDesc: "",
          colType: "",
          translate: "",
          orderType: "",
          orderNum: "",
          cmm: false
        }
      ];

      ajax_gm_handleBusinessByTargetKpi(
        "find_columns_gms",
        { eventCode: e }
      ).then(response => {
        console.log("find_columns_gms", response.data);
        if (response.code == 1) {
          obj.columnslist = response.data;
        }
      });
    },
    selectziduan(e, obj, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].trueField == e) {
          obj.colType = arr[i].colType;
          obj.eventCode = arr[i].eventCode;
          obj.fieldDesc = arr[i].fieldDesc;
          obj.translate = arr[i].translate;
          obj.orderType = arr[i].orderType;
          obj.orderNum = arr[i].orderNum;
          obj.cmm = false;
        }
      }
    },
    clickziduan(e, v, obj, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].trueField == v) {
          obj.colType = arr[i].colType;
          obj.eventCode = arr[i].eventCode;
          obj.fieldDesc = arr[i].fieldDesc;
          obj.translate = arr[i].translate;
          obj.orderType = arr[i].orderType;
          obj.orderNum = arr[i].orderNum;
          obj.cmm = false;
        }
      }
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.sizePage = e;
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.currentPage = e;
    },
    chaxunbtn() {
      // this.objdata.queryTime = this.objdata.selecttime[0] + " - " + this.objdata.selecttime[1]

      console.log(this.objdata);
      var updateKpiInfo = JSON.stringify(this.objdata);
      var objdatacopy = JSON.parse(JSON.stringify(this.objdata));

      // delete objdatacopy.jisuanguizelist;
      // delete objdatacopy.selecttime;
      // delete objdatacopy.data;
      for (var i = 0; i < objdatacopy.tables.length; i++) {
        if (objdatacopy.tables[i].eventCode == "") {
          this.$message.error("请完善空置表名")
          return false
        }
        for (var j = 0; j < objdatacopy.tables[i].columns.length; j++) {
          if (objdatacopy.tables[i].columns[j].eventCode == "") {
            this.$message.error("请完善空置字段")
            return false
          }
        }
      }
      this.modelloading = true;

      objdatacopy.updateKpiInfo = updateKpiInfo;
      // console.log(JSON.stringify(objdatacopy));
      this.tableData = JSON.parse(JSON.stringify({ tbody: [], thead: [], ttitle: [], page: { result: [] } }));
      ajax_gm_customqueryTest("", objdatacopy).then(
        response => {
          // console.log(response.data);
          if (response.code == 1) {
            // if(response.data.kpiId != ""){
            //    this.objdata.code = "";
            //    delete this.objdata.kpiId
            // }
            this.objdata.code = response.data.kpiId;
            this.tableData = JSON.parse(JSON.stringify(response.data));
            this.chaxunchengong = true;
          } else {
            alert(response.msg);
          }
          this.modelloading = false;
        }
      );
    },
    baocunbtn() {

      if (this.objdata.name == "") {
        alert("请填写指标名称");
        return false;
      }
      if (this.objdata.desc == "") {
        alert("请填写指标说明");
        return false;
      }

      // this.objdata.queryTime =
      //   this.formatTimeToStr(this.objdata.selecttime[0], "yyyy-MM-dd") +
      //   " - " +
      //   this.formatTimeToStr(this.objdata.selecttime[1], "yyyy-MM-dd");

      console.log(JSON.parse(JSON.stringify(this.objdata)));
      var updateKpiInfo = JSON.stringify(this.objdata);
      var objdatacopy = JSON.parse(JSON.stringify(this.objdata));

      // delete objdatacopy.jisuanguizelist;
      // delete objdatacopy.selecttime;
      // delete objdatacopy.data;

      for (var i = 0; i < objdatacopy.tables.length; i++) {
        if (objdatacopy.tables[i].eventCode == "") {
          this.$message.error("请完善空置表名")
          return false
        }
        for (var j = 0; j < objdatacopy.tables[i].columns.length; j++) {
          if (objdatacopy.tables[i].columns[j].eventCode == "") {
            this.$message.error("请完善空置字段")
            return false
          }
        }
      }
      objdatacopy.updateKpiInfo = updateKpiInfo;
      console.log(JSON.stringify(objdatacopy));
      fenxisave("", objdatacopy).then(response => {
          console.log(response);
          if (response.code == 1) {
            this.objdata.code = response.data.code;
            this.xinzengtype = true;
            this.$message.success("保存成功")
            ajax_zhibiaoliebiao( "").then(response => {
              if (response.code == 1) {
                this.gridData = response.data;
              }
            });
          } else {
            alert(response.msg);
          }
        }
      );
    },
    lingbaocunbtn() {
      this.objdata.code = "";
      if (this.objdata.name == "") {
        alert("请填写指标名称");
        return false;
      }
      if (this.objdata.desc == "") {
        alert("请填写指标说明");
        return false;
      }

      // this.objdata.queryTime =
      //   this.formatTimeToStr(this.objdata.selecttime[0], "yyyy-MM-dd") +
      //   " - " +
      //   this.formatTimeToStr(this.objdata.selecttime[1], "yyyy-MM-dd");

      console.log(JSON.stringify(this.objdata));
      var updateKpiInfo = JSON.stringify(this.objdata);
      var objdatacopy = JSON.parse(JSON.stringify(this.objdata));

      // delete objdatacopy.jisuanguizelist;
      // delete objdatacopy.selecttime;
      // delete objdatacopy.data;

      for (var i = 0; i < objdatacopy.tables.length; i++) {
        if (objdatacopy.tables[i].eventCode == "") {
          this.$message.error("请完善空置表名")
          return false
        }
        for (var j = 0; j < objdatacopy.tables[i].columns.length; j++) {
          if (objdatacopy.tables[i].columns[j].eventCode == "") {
            this.$message.error("请完善空置字段")
            return false
          }
        }
      }

      objdatacopy.updateKpiInfo = updateKpiInfo;
      console.log(JSON.stringify(objdatacopy));
      fenxisave(objdatacopy).then(
        response => {
          console.log(response);
          if (response.code == 1) {
            this.objdata.code = response.data.code;
            this.xinzengtype = true;
            this.$message.success("保存成功")
            ajax_zhibiaoliebiao("").then(response => {
              if (response.code == 1) {
                this.gridData = response.data;
              }
            });
          } else {
            alert(response.msg);
          }
        }
      );
    },
    bianjiliechaxun() {
      console.log(this.tableData.ttitle);
      // this.objdata.queryTime =
      //   this.formatTimeToStr(this.objdata.selecttime[0], "yyyy-MM-dd") +
      //   " - " +
      //   this.formatTimeToStr(this.objdata.selecttime[1], "yyyy-MM-dd");

      // this.objdata.titles = this.tableData.ttitle;
      // this.objdata.mtitles = this.tableData.mtitle;

      console.log(this.objdata.titles);
      console.log(JSON.stringify(this.objdata));
      var updateKpiInfo = JSON.stringify(this.objdata);
      var objdatacopy = JSON.parse(JSON.stringify(this.objdata));

      // delete objdatacopy.jisuanguizelist;
      // delete objdatacopy.selecttime;
      // delete objdatacopy.data;

      for (var i = 0; i < objdatacopy.tables.length; i++) {
        if (objdatacopy.tables[i].eventCode == "") {
          this.$message.error("请完善空置表名")
          return false
        }
        for (var j = 0; j < objdatacopy.tables[i].columns.length; j++) {
          if (objdatacopy.tables[i].columns[j].eventCode == "") {
            this.$message.error("请完善空置字段")
            return false
          }
        }
      }

      this.modelloading = true;

      objdatacopy.updateKpiInfo = updateKpiInfo;
      console.log(JSON.stringify(objdatacopy));

      fenxiquery( objdatacopy).then(response => {
          console.log(response);
          if (response.statusCode == 1) {
            this.objdata.code = response.data.kpiId;
            this.modelloading = false;
            this.xinzengtype = false;

            console.log(JSON.stringify(response.data.echartsData));
            // this.objdata.titles = response.data.tableData.ttitle;
            this.tableData = JSON.parse(JSON.stringify(response.data));
            // this.dataLength = response.data.tableData.tbody.length;
            this.chaxunchengong = true;
            this.shaixuantanchukuang = false;
          } else {
            alert(response.message);
          }
        }
      );
    },
    changeinput(e, property) {
      for (var i = 0; i < this.tableData.ttitle.length; i++) {
        if (this.tableData.ttitle[i].property == property) {
          this.tableData.ttitle[i].label = e;
        }
      }
    },
    changeswitch(e, property) {
      for (var i = 0; i < this.tableData.ttitle.length; i++) {
        if (this.tableData.ttitle[i].property == property) {
          this.tableData.ttitle[i].state = e;
        }
      }
    },
    changeswitchhebin(e, property) {
      for (var i = 0; i < this.tableData.mtitle.length; i++) {
        if (this.tableData.mtitle[i].property == property) {
          this.tableData.mtitle[i].state = e;
        }
      }
    },
    changehengshu(e, property) {
      for (var i = 0; i < this.tableData.ttitle.length; i++) {
        if (this.tableData.ttitle[i].arrangement != "0") {
          if (e == "2") {
            if (this.tableData.ttitle[i].property == property) {
              this.tableData.ttitle[i].arrangement = e;
            } else {
              this.tableData.ttitle[i].arrangement = "4";
            }
          } else if (e == "1") {
            this.tableData.ttitle[i].arrangement = "1";
          }
        }
      }
    },
    handleClose(done) {
      done();
    },
    // 操作已存报表
    draweropen() {
      this.drawer = true;
      ajax_zhibiaoliebiao("").then(response => {
        console.log(response);
        if (response.code == 1) {
          this.gridData = response.data;
          this.originalGridData = JSON.parse(JSON.stringify(response.data))
        }
      });
    },

    // 监听已存报表搜索
    gridDatasousuoinput() {
      var arr = [];
      if (this.gridDatasousuo != "") {
        for (var i = 0; i < this.originalGridData.length; i++) {
          if (this.originalGridData[i].name.toLowerCase().indexOf(this.gridDatasousuo.toLowerCase()) != -1) {
            arr.push(this.originalGridData[i]);
          }
        }
        this.gridData = arr;
      } else {
        this.gridData = this.originalGridData;
      }
    },




    addbaobiao() {
      if (this.xinzengtype) {
        // 清空
        this.objdata = {
          titles: [],
          name: "",
          code: "",
          platform: this.$store.getters.environment,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.userInfo.realname,
          desc: "",
          appkey: this.$store.getters.appkey,
          // queryTime: "",
          // selecttime: [],
          tables: [
            {
              tableName: "",
              eventCode: "",
              columns: [
                {
                  eventCode: "",
                  trueField: "",
                  fieldDesc: "",
                  colType: "",
                  translate: "",
                  orderType: "",
                  orderNum: "",
                  cmm: false
                }
              ],
              columnslist: []
            }
          ]
        };

        this.tableData = { tbody: [], thead: [], ttitle: [], page: { result: [] } }
        this.chartData = "";
        this.currentPage = 1;
        this.dataLength = 1;
        this.sizePage = 10;
        this.chaxunchengong = false;
      } else {
        this.$confirm("是否永久保存此次查询?", "提示", {
          confirmButtonText: "保存",
          cancelButtonText: "不保存",
          type: "warning"
        })
          .then(() => {
            this.baocunbtn();
          })
          .catch(() => {
            this.xinzengtype = true;
            this.objdata = {
              titles: [],
              name: "",
              code: "",
              platform: this.$store.getters.environment,
              userId: this.$store.getters.userId,
              userName: this.$store.getters.userInfo.realname,
              desc: "",
              appkey: this.$store.getters.appkey,
              // queryTime: "",
              // selecttime: [],
              tables: [
                {
                  tableName: "",
                  eventCode: "",
                  columns: [
                    {
                      eventCode: "",
                      trueField: "",
                      fieldDesc: "",
                      colType: "",
                      translate: "",
                      orderType: "",
                      orderNum: "",
                      cmm: false
                    }
                  ],
                  columnslist: []
                }
              ]
            };

            this.tableData = { tbody: [], thead: [], ttitle: [], page: { result: [] } }
            this.chartData = "";
            this.currentPage = 1;
            this.dataLength = 1;
            this.sizePage = 10;
            this.chaxunchengong = false;
          });
      }
    },
    huisuchaxun() {
      // this.objdata.queryTime =
      //   this.formatTimeToStr(this.objdata.selecttime[0], "yyyy-MM-dd") +
      //   " - " +
      //   this.formatTimeToStr(this.objdata.selecttime[1], "yyyy-MM-dd");

      console.log(JSON.stringify(this.objdata));
      var updateKpiInfo = JSON.stringify(this.objdata);
      var objdatacopy = JSON.parse(JSON.stringify(this.objdata));

      // delete objdatacopy.jisuanguizelist;
      // delete objdatacopy.selecttime;
      // delete objdatacopy.data;

      for (var i = 0; i < objdatacopy.tables.length; i++) {
        if (objdatacopy.tables[i].eventCode == "") {
          this.$message.error("请完善空置表名")
          return false
        }
        for (var j = 0; j < objdatacopy.tables[i].columns.length; j++) {
          if (objdatacopy.tables[i].columns[j].eventCode == "") {
            this.$message.error("请完善空置字段")
            return false
          }
        }
      }
      this.modelloading = true;

      objdatacopy.updateKpiInfo = updateKpiInfo;
      console.log(JSON.stringify(objdatacopy));
      this.tableData = JSON.parse(JSON.stringify({ tbody: [], thead: [], ttitle: [], page: { result: [] } }));
      ajax_gm_customqueryTest("", objdatacopy).then(
        response => {
          console.log(response.data);
          if (response.code == 1) {
            // this.objdata.code = response.data.kpiId;
            this.tableData = JSON.parse(JSON.stringify(response.data));
            this.chaxunchengong = true;
          } else {
            alert(response.msg);
          }
          this.modelloading = false;
          this.xinzengtype = false;
        }
      );

      // objdatacopy.updateKpiInfo = updateKpiInfo;
      // console.log(JSON.stringify(objdatacopy));

      // fenxiquery(this.defined.testpro, this.$store.getters.appkey, objdatacopy).then(
      //   response => {
      //     console.log(response);
      //     if (response.statusCode == 1) {
      //       this.modelloading = false;
      //       this.xinzengtype = false;

      //       console.log(JSON.stringify(response.data.echartsData));

      //       this.tableData = JSON.parse(JSON.stringify(response.data));
      //       // this.dataLength = response.data.tableData.tbody.length;
      //       // this.objdata.titles = response.data.tableData.ttitle;
      //       this.chaxunchengong = true;
      //     } else {
      //       alert(response.message);
      //     }
      //   }
      // );
    },
    handleEditupdate(index, row) {
      queryByCode(row.code).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.objdata = response.data;
          this.objdata.code = row.code
          this.huisuchaxun();
          this.drawer = false;
        }
      });
    },
    handleEditremove(index, row) {
      // ajax_zhibiaodel
      this.$confirm("此操作将永久删除该报表, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ajax_zhibiaodel(row.id).then(response => {
            if (response.code == 1) {
              ajax_zhibiaoliebiao("").then(response => {
                console.log(response);
                if (response.code == 1) {
                  this.gridData = response.data;
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                }
              });
            } else {
              this.$message(response.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    }
  },
  filters: {
    neirongsuojian(value) {
      return value.substring(0, 15) + "...";
    },
    rules(value) {
      if (value == "and") {
        return "且";
      } else if (value == "or") {
        return "或";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 8px 15px 7px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-select-group .el-select-dropdown__item {
  padding-left: 40px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.el-table--medium td,
.el-table--medium th {
  padding: 6px;
}
.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style>
.el-tag {
  background: none;
  border: none;
}
.el-loading-mask {
  z-index: 5;
}
.fl {
  float: left;
}
.mgleft {
  margin-left: 20px;
  cursor: pointer;
}
.liaojianliebiao {
  width: 96%;
  padding: 0px 2%;
  min-width: 1650px;
  /* max-width: 1650px; */
  border-bottom: 1px solid #dedede;
  background: rgb(244, 246, 250);
}
.tiaojianyijilist {
  width: 100%;
  line-height: 44px;
  font-size: 12px;
  color: #666;
}
.tiaojianyijilistlastbottom {
  border-bottom: 1px solid #dedede;
}
.tiaojianyijilistlast:last-child {
  border-bottom: none;
}
.tiaojianyijiname {
  width: 100px;
}
.tiaojianyijiselect_list {
  /* width: 400px; */
}
.tiaojianyijiselect_list1 {
  width: 200px;
}
.tiaojianyijiselect_item {
}

.liebiaozitiaojian {
  /* width: 100%;
  margin-left: 190px;
  margin-top: 1px;
  margin-bottom: 1px;
  position: relative; */
  width: 100%;
  padding-left: 190px;
  margin-top: 1px;
  margin-bottom: 1px;
  position: relative;
  background: rgb(219, 223, 231);
  margin-left: -25px;
}
.liebiaozitiaojian_erji {
  width: 100%;
}
.addifor {
  position: absolute;
  left: 120px;
  top: 50%;
  height: 30px;
  margin-top: -15px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  border: 1px solid #aaa;
  cursor: pointer;
}
.addifor1 {
  position: absolute;
  left: 120px;
  top: 50%;
  height: 30px;
  margin-top: -15px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  border: 1px solid #dedede;
  cursor: pointer;
}
.elselect {
  margin-right: 10px;
}
.shijianliebiao {
  max-width: 500px;
}
.shijianliebiao .el-select-group__wrap {
  float: left;
}
.shijianliebiao .el-select-group__title {
  color: #1890ff;
}
.shijianliebiao .el-select-dropdown__item {
  float: left;
}
.bianjilie_div {
  width: 100%;
  box-sizing: border-box;
  float: left;
  height: 30px;
  line-height: 30px;
  margin-bottom: 5px;
}

.cascaderselecthover .el-cascader-node.is-selectable.in-active-path {
  color: #05b3d1;
}
</style>